import { render } from "./purchase-orders.vue?vue&type=template&id=72d69ea1&scoped=true"
import script from "./purchase-orders.vue?vue&type=script&lang=js"
export * from "./purchase-orders.vue?vue&type=script&lang=js"

import "./purchase-orders.vue?vue&type=style&index=0&id=72d69ea1&scoped=true&lang=css"

import exportComponent from "/home/runner/work/inventflux-frontend/inventflux-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72d69ea1"]])

export default __exports__